import React, { Component } from 'react';
import {
  Col,
  Row,
  Button,
  Card,
  ListGroup,
  ListGroupItem,
} from 'react-bootstrap';
import { MdNavigateBefore } from 'react-icons/md';
import classNames from 'classnames';
import ReactGA from 'react-ga';
import Dropzone from 'react-dropzone';
import {
  getContactList,
  setContactList,
} from '../../../../services/company.service';
import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import messages from '../../../Admin/messages';
import extractData from '../../../../services/data.processing';
import './import-contacts.css';
const baseStyle = {
  borderWidth: 2,
  borderColor: '#dadada',
  borderStyle: 'dashed',
  borderRadius: '20px',
  padding: '25%',
};
class ImportContacts extends Component {
  constructor() {
    super();
    this.state = {
      files: [],
    };
  }

  UNSAFE_componentWillMount() {
    ReactGA.pageview(window.location.pathname + window.location.search);
    this.getContactList();
  }

  formatImportHistoryDate = (date) => {
    let formattedDate = new Date(date);
    let month = `${formattedDate.getMonth() + 1}`;
    let day = `${formattedDate.getDate()}`;
    const year = formattedDate.getFullYear();
    let hour = formattedDate.getHours();
    let minutes = formattedDate.getMinutes();
    if (month.length < 2) month = `0${month}`;
    if (day.length < 2) day = `0${day}`;
    if (minutes < 10) minutes = `0${minutes}`;
    if (hour < 10) hour = `0${hour}`;
    return `${[year, month, day].join('.')} ${hour}:${minutes}`;
  };

  getContactList = async () => {
    let token = this.props.users.accessToken;
    const contactListResponse = await getContactList(token);
    if (contactListResponse.status === 200) {
      const files = await extractData(contactListResponse);
      this.setState({ files: files });
    }
  };

  onDrop = async (file) => {
    let token = this.props.users.accessToken;
    await setContactList(token, file[0]);
    this.getContactList();
  };

  renderContactListUploadSatatus = () =>
    this.state.files.map((item, i) => (
      <ListGroupItem key={i}>
        <Row>
          <Col md={4} xs={4} className="file-upload-info">
            {item.filename}
          </Col>
          <Col md={4} xs={4} className="file-upload-info">
            {this.formatImportHistoryDate(item.created_at)}
          </Col>
          <Col md={4} xs={4}>
            {item.status === 1 ? (
              <span className="green-status">
                <FormattedMessage {...messages.Successful} />
              </span>
            ) : (
              <span>
                <FormattedMessage {...messages.Failed} />
              </span>
            )}
          </Col>
        </Row>
      </ListGroupItem>
    ));

  render() {
    return (
      <Row className="contacts-import">
        <Col md={6} sm={12} style={{ height: '100%' }}>
          <Card className="card-box">
            <Card.Body>
              <Dropzone onDrop={this.onDrop}>
                {({ getRootProps, getInputProps, isDragActive }) => {
                  let styles = { ...baseStyle };
                  return (
                    <div
                      style={styles}
                      {...getRootProps()}
                      className={classNames('dropzone', {
                        'dropzone--isActive': isDragActive,
                      })}
                    >
                      <input {...getInputProps()} />
                      {isDragActive ? (
                        <p>
                          <FormattedMessage {...messages.dropFile} />
                        </p>
                      ) : (
                        <div className="text-center">
                          <p>
                            <FormattedMessage {...messages.dropFile} />
                          </p>
                          <p> or </p>
                          <p>
                            <Button
                              className="form-btn btn btn-default"
                              type="submit"
                            >
                              <FormattedMessage {...messages.selectFile} />
                            </Button>
                          </p>
                        </div>
                      )}
                    </div>
                  );
                }}
              </Dropzone>
            </Card.Body>
          </Card>
        </Col>
        <Col md={6} sm={12} style={{ height: '100%' }}>
          <Card className="card-box">
            <Card.Body className="contact-panel-body">
              <div className="contacts-import-header">
                <div className="navigate-before">
                  <div md={3}>
                    <MdNavigateBefore
                      className="before"
                      onClick={() => this.props.history.goBack()}
                    />
                  </div>
                </div>
                <div>
                  <h5 className="cardTitle">
                    <FormattedMessage {...messages.UploadHistory} />
                  </h5>
                </div>
              </div>
              <hr></hr>
              <ListGroup className="list-report">
                <ul className="">{this.renderContactListUploadSatatus()}</ul>
              </ListGroup>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    );
  }
}

function mapDispatchToProps(dispatch) {
  return {};
}

const mapStateToProps = (state) => {
  const { users } = state.toJS();
  return { users };
};

export default connect(mapStateToProps, mapDispatchToProps)(ImportContacts);
